import { bus } from '@/main';

const MOBILE_COUNTRY_SELECTOR_ELEMENT_ID = 'mobile-language-region-selector';

export default {
  mounted() {
    bus.$on('openCountrySelector', () => {
      this.openCountrySelector();
    });
  },
  computed: {
    mobileLanguageOptions() {
      return this.languageOptions.map((option) => ({
        ...option,
        active: option.value === this.language,
        key: 'language',
        action: 'change',
      }));
    },
    countrySelectorMobileItem() {
      return {
        id: MOBILE_COUNTRY_SELECTOR_ELEMENT_ID,
        label: this.translate('Language and Regions'),
        icon: 'globe',
        submit: 'country-submit',
        opened: this.languageAndRegionsOpened,
        options: [
          {
            label: this.translate('Language'),
            options: this.mobileLanguageOptions,
          },
          {
            label: this.translate('Region'),
            options: this.mobileRegions,
            opened: this.languageAndRegionsOpened,
          },
        ],
      };
    },
    mobileRegions() {
      const countryValue = this.country?.value || 'USA';

      return this.regions.map(({ title, options }) => {
        const formattedOptions = options.map((item) => ({
          ...item,
          active: item.value === countryValue,
          key: 'country',
          action: 'change',
        }));

        return {
          label: title,
          options: formattedOptions,
          opened:
            this.languageAndRegionsOpened &&
            formattedOptions.some((option) => option.active === true),
        };
      });
    },
  },
  data() {
    return {
      languageAndRegionsOpened: false,
    };
  },
  methods: {
    openCountrySelector() {
      this.$store.dispatch('country/getCountriesWithGeoSupport');

      this.languageAndRegionsOpened = false;
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });

      setTimeout(() => {
        if (!this.shouldShowMobileVersion) {
          this.$refs.header.openCountrySelector();
          return;
        }

        this.$refs.header.setMobileMenuActivity(true);
        this.languageAndRegionsOpened = true;

        setTimeout(() => {
          const countrySelectorElement = document.querySelector(
            `#${MOBILE_COUNTRY_SELECTOR_ELEMENT_ID}`,
          );
          const top = countrySelectorElement?.offsetTop || 427;
          document.querySelector('.jlc-appHeaderMobileNav__container').scrollTo({
            top,
            behavior: 'smooth',
          });
        }, 400);
      }, 100);
    },
  },
};
